export const shipping = {
    amounts: {
        MIN_ITEM_PRICE_USD: 1000,
        PROMO_AMOUNT_USD: 500,
    },
    texts: {
        FREE_SHIPPING: 'Free shipping',
        FIRST_ORDER: ' on your first order',
        CREDIT_APPLIED: 'Your 500$ shipping credit will be applied',
    },
    tooltip: {
        texts: {
            MAIN: 'Save up to $500 off shipping costs when you enter code TRADESHIP at checkout.',
            END: 'apply.',
        },
        link: {
            URL: '/info/tradeship/',
            TEXT: 'T & C',
        },
    },
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/VerifiedTradePromo/verifiedTradePromoConstants.es.js